import { EnumSignupSteps, SignupFormField } from '../types/signup'

interface SignupStep {
  stepName: EnumSignupSteps
  formFields: Array<SignupFormField>
}

export const SIGNUP_STEPS: Array<SignupStep> = [
  {
    stepName: EnumSignupSteps.NAME,
    formFields: ['firstname', 'lastname'],
  },
  {
    stepName: EnumSignupSteps.EMAIL,
    formFields: ['email'],
  },
  {
    stepName: EnumSignupSteps.PASSWORD,
    formFields: ['password'],
  },
  {
    stepName: EnumSignupSteps.EMAIL_CONFIRM,
    formFields: [],
  },
]
